import { createSlice } from "@reduxjs/toolkit";

const lineupsSlice = createSlice({
  name: "lineups",
  initialState: {
    whereClause: null,
  },
  reducers: {
    setWhereClause: (state, action) => {
      state.whereClause = action.payload;
    },
  },
});

export const { setWhereClause } = lineupsSlice.actions;
export default lineupsSlice.reducer;
